import { useCurrentReflection } from '@/hooks'
import { adminclassMentorGraduatesTermAtom, selectedRoleAtom } from '@/store'
import { useApiQuery } from '@/utils/use-api-query'
import { Moment, moment } from '@seiue/moment'
import { useAtomValue } from 'jotai'

import { SemesterInfo } from '../pages/DataBoard/types'

/**
 * 获取学期信息
 *
 * @returns semesterInfo
 */
export const useSemesterInfo = (date?: Moment) => {
  const reflection = useCurrentReflection()

  const {
    data: res,
    loading,
    reload,
  } = useApiQuery({
    apiName: 'querySemesterData',
    params: {
      query: {
        advisor_usin: reflection?.usin || '',
        date: date ? date.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
      },
    },
    disable: !reflection?.usin,
  })

  const { data: semesterData } = res || {}

  const semesterInfo = semesterData?.[0] as SemesterInfo | undefined

  return {
    semesterInfo,
    loading,
    reload,
  }
}

/**
 * 获取通用查询参数
 *
 * @returns commonQuery
 */
export const useCommonQuery = () => {
  const reflection = useCurrentReflection()
  const selectedRole = useAtomValue(selectedRoleAtom)
  const adminclassGraduateTermName = useAtomValue(
    adminclassMentorGraduatesTermAtom
  )

  return {
    reflection,
    selectedRole,
    adminclassGraduateTermName,
  }
}
